import { lazy } from 'react';
import type { PageRouter } from '@tools/ui/types';
import { ACH_MAIN_TABS } from './i18.ach';

const AchTable = lazy(
  () => import(/* webpackChunkName: "LuciRoutes" */ './AchTableDisplay')
);

export const achRoutes: PageRouter[] = [
  {
    name: ACH_MAIN_TABS.NEW,
    path: `/${ACH_MAIN_TABS.NEW}`,
    exact: false,
    component: AchTable,
    tabs: []
  }
];
